import { classRegex } from '../class-regex';
import { getClass } from '../get-class';
import { hasClass } from '../has-class';

export function removeClass(element: Element, className: string) {
	if (element && hasClass(element, className)) {
		const regex = classRegex(className);
		element.setAttribute('class', getClass(element).replace(regex, ' ').trim());
	}
}

export function removeClassFactory(className: string) {
	return (element: Element) => {
		removeClass(element, className);
	};
}

export function removeClassOnCollection(
	elements: Element[],
	className: string
) {
	elements.forEach(removeClassFactory(className));
}
